import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = m[1];
    api
      .post("/auth/google/session", { session_id })
      .then((r) => {
        setUser(r.data);
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: r.data } });
      })
      .catch(() => {
        navigate("/", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-background text-brand-primary">
      <div className="text-center">
        <div className="h-10 w-10 border-2 border-brand-green border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-brand-secondary">Accesso in corso...</p>
      </div>
    </div>
  );
}
